
import searchInput from '../components/SearchInput.vue';
import taskInfo from '../components/TaskInfo.vue';

import Sticky from 'vux/src/components/sticky/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
components: {
searchInput,
Sticky,
taskInfo,
Divider,
InlineLoading,
LoadMore,
},
props:{
type: {
type: String,
default: '待办任务'
},
url: {
type: String,
default: '/wechat/myTaskWait.do'
},
},
data: function () {
return {
searchValue: '',

tasks: [

],

openId:'',
taskType: '',
applyUser: '',

currentTasks: [

],

pageIndex: 1,
pageSize: 5,
total: 0, //总数
isloading: false,//是否加载数据
scrollLoading: true, //判断是否滚动加载数据
showReflesh: false, //获取数据失败
checkSearch: false, //检查是否搜索过
}
},
created () {

this.openId = window.sessionStorage.getItem("openId");

if (this.openId == null || this.openId == '') {
this.$vux.toast.text("openId为空", 'top');
} else {
this.getUserInfo(this.openId);
}


window.addEventListener('scroll', this.handleScroll, true);
},
methods: {

getUserInfo (openId) {
const url = 'wechat/queryUser.do?openId=' + openId;

const thiss = this;
this.$axios({
method: 'get',
url: url
}).then((response) => {

if (response.data.code === 200) {

if (response.data.result.espstatus == null || String(response.data.result.espstatus) === '0') {
thiss.$router.push({path: '/register'});
} else if (String(response.data.result.espstatus) === '1' || String(response.data.result.espstatus) === '3') {
thiss.$router.push({path: '/personInfo'});
} else {
thiss.getTask(0);
}
} else {
thiss.$vux.toast.hide();
thiss.$router.push({path: '/register'});
}
}).catch((error) => {

});
},

handleClick () {
if (this.isSearch()){
this.$vux.toast.text("请输入搜索内容");
return;
}
this.checkSearch = true;
this.handleEnter();

},

isSearch () {
if (this.searchValue == '' || this.searchValue == undefined || this.searchValue == null) {
return true;
} else {
return false;
}
},

handleChange (event) {
if (event == '' || event == null || event === undefined) {
return;
}

const keyCode = event.keyCode;
if (keyCode == 8 && this.isSearch() && this.checkSearch) {
this.handleEnter();
this.checkSearch = false;
}
},

handleEnter () {
this.taskType = this.checkSearchValue(this.searchValue);



if (this.taskType === '') {
this.applyUser = this.searchValue;
} else {
this.applyUser = '';
}
this.pageIndex = 1;
this.currentTasks = [];
this.tasks = [];
this.getTask(0);

},

checkSearchValue (value) {
if (value === '' || value == null) {
return '';
}
const sign = '在线签约';
const approval = '融资申请';
if (sign.indexOf(value) != -1) {
return 1;
}
if (approval.indexOf(value) != -1) {
return 0;
}

return '';
},


getTask (length) {

if (this.pageIndex != 1) {
this.isloading = true;
}
const url = this.url;
const _this = this;
this.$axios({
method: 'get',
url: url,
params: {
openId: _this.openId,
applyUser: _this.applyUser,
taskType: _this.taskType,
pageIndex: _this.pageIndex,
pageSize: _this.pageSize,
}
}).then((response) => {

_this.showReflesh = false;
if (response.data.code === 200) {

_this.tasks = response.data.result.tasks;
_this.handleData(length);
_this.isloading = false;
_this.scrollLoading = true;
} else {

}
}).catch(function(err){


_this.isloading = false;
_this.showReflesh = true;
})
},
handleTask (value) {
const projectId = value.projectid;
const taskType = value.taskType;
const productName = value.productName;
const productCode = value.productCode;

if (this.type === '已办任务') {
const deletedType = value.deletedType;
const deleted = value.deleted;
if (deletedType == '1' && deleted == '1') {
this.$vux.confirm.show({content: '该申请已被退回！', showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
return;
} else if (deleted == '1' && deletedType == '2') {
this.$vux.confirm.show({content: '该申请已被删除！', showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
return;
}
}

if (taskType == '1') {

this.$router.push({
path: '/signFiles',
query: {
projectId: projectId,
taskType: taskType,
productCode: productCode,
currentkey: 'task',
}
});
} else {

this.$router.push({
path: '/financingApplication',
query: {
projectId: projectId,
productCode: productCode,
taskType: taskType,
currentkey: 'task',
}
});
}
},

handleData (length) {
const thiss = this;
this.tasks.forEach(function (item) {
item.applicationAmount = thiss.filterMoney(item.applicationAmount);
item.applicationDate = thiss.dateFormat(item.applicationDate);
item.approvalDate = thiss.dateFormat(item.approvalDate);
item.borrowingBalance = thiss.filterMoney(item.borrowingBalance);
item.contractDate = thiss.dateFormat(item.contractDate);
if (item.productCode == '3') {
item.borrowingTerm = item.borrowingTerm + '日';
} else {
item.borrowingTerm = item.borrowingTerm + '个月';
}
if (thiss.type == '待办任务') {
item.submitDate = thiss.timeFormat(item.submitDate);
} else {
item.submitDate = thiss.dateFormat(item.submitDate);
}
});

this.handlePagesData(length);
},

handlePagesData (length) {

const _this = this;
for (let i = length; i < this.tasks.length; i++) {
_this.currentTasks.push(_this.tasks[i]);
}

},

handleScroll () {

const scrollHeight = document.documentElement.scrollHeight; 
const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
const clientHeight = document.documentElement.clientHeight;

const height = scrollHeight - scrollTop - clientHeight <= 30;

if (this.scrollLoading && height) {
this.scrollLoading = false;


if (this.tasks.length < this.pageSize) {
return;
}

this.pageIndex = this.pageIndex + 1;
this.getTask(0);
}

},

filterMoney(value) {
if (!value) return '0';
let intPart = Math.floor(value); 
var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); 
let floatPart = ".00"; 
let value2Array = String(value).split(".");

if (value2Array.length == 2) {
floatPart = value2Array[1].toString(); 
if (floatPart.length == 1) { //补0,实际上用不着
return intPartFormat + "." + floatPart + '0';
} else {
return intPartFormat + "." + floatPart.substring(0, 2);
}
} else {
return intPartFormat + floatPart;
}
},

dateFormat:function(date){
if(date && date !== '' && date != undefined){

date = new Date(date.replace(/-/g,'/'));
let year = date.getFullYear();
let month = date.getMonth() + 1;
if(month < 10){
month = '0' + month;
}
let day = date.getDate();
if(day < 10){
day = '0' + day;
}
return year+'-'+month+'-'+day;
} else {
return '';
}
},

timeFormat:function(date){
if(date && date !== '' && date != undefined){

date = new Date(date.replace(/-/g,'/'));
let year = date.getFullYear();
let month = date.getMonth() + 1;
let hour = date.getHours();
let min = date.getMinutes();
let se = date.getSeconds();
if(month < 10){
month = '0' + month;
}
let day = date.getDate();
if(day < 10){
day = '0' + day;
}
if (hour < 10) {
hour = '0' + hour;
}
if (min < 10) {
min = '0' + min;
}
if (se < 10) {
se = '0' + se;
}
return year+'-'+month+'-'+day + ' ' + hour + ':' + min + ':' + se;
} else {
return '';
}
},

reflesh () {

let tasklength = 0;

if (this.tasks.length < this.pageSize && this.tasks.length > 0) {
tasklength = this.tasks.length;
}
if (this.tasks.length == this.pageSize) {
tasklength = 0;
this.pageIndex += 1;
}
this.getTask(tasklength);
},
},
mounted () {

},
beforeDestroy () {

window.removeEventListener('scroll', this.handleScroll, true);
}
}



// WEBPACK FOOTER //
// ./src/pages/WaitTask.vue